/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
jQuery( function($) {
    const $body = $('body');
    $('.hh-mobile-menu-toggle').click(function () {
        const $this = $(this);
        const isToggled = $this.parent().hasClass('toggled');

        if(isToggled){
            $body.addClass('overflow-hidden');
        } else {
            $body.removeClass('overflow-hidden');
        }
    })
})